import React, { Component } from "react";
import { connect } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import NavBar from "../common/navbar";
import Footer from "../common/footer";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class CategorySuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      cancelrequest: false,
    };
  }

  componentWillMount() {
    let { assettype, actiontype } = this.props.location.state;
    if (assettype === "PRODUCT" && actiontype === "UPLOAD") {
      this.setState({
        message: "Product image uploaded",
      });
    } else if (assettype === "PRODUCT" && actiontype === "DELETE") {
      this.setState({
        message: "Product image deleted",
      });
    } else if (assettype === "CATEGORY" && actiontype === "UPLOAD") {
      this.setState({
        message: "Category image uploaded",
      });
    } else if (assettype === "CATEGORY" && actiontype === "DELETE") {
      this.setState({
        message: "Category image deleted",
      });
    } else if (assettype === "VENDOR" && actiontype === "UPLOAD") {
      this.setState({
        message: "Vendor image uploaded",
      });
    } else if (assettype === "VENDOR" && actiontype === "DELETE") {
      this.setState({
        message: "Vendor image uploaded",
      });
    }
  }

  backToHome = () => {
    const assettype = this.props.location.state.assettype;

    if (assettype === "CATEGORY") {
      this.props.history.push("/categorys");
    } else if (assettype === "VENDOR") {
      this.props.history.push("/vendormaster");
    } else if (assettype === "PRODUCT") {
      this.props.history.push("/productmaster");
    }
  };

  render() {
    return (
      <>
        <NavBar />
        <div
          className="container-fluid"
          style={{ paddingBottom: 50, paddingTop: 50 }}
        >
          <div className="row justify-content-center">
            <div className="col-md-6 text-center">
              <FontAwesomeIcon
                icon="check-circle"
                color="#4CAF50"
                style={{ fontSize: 140 }}
              />

              <div style={{ marginTop: 30, fontSize: 30, fontWeight: "bold" }}>
                {this.state.message}
              </div>

              <div style={{ marginTop: 30, fontSize: 30, fontWeight: "bold" }}>
                <button
                  className="btn btn-success btn-primary"
                  style={{ fontSize: 13, fontWeight: "bold" }}
                  onClick={() => this.backToHome()}
                >
                  <FontAwesomeIcon
                    icon="reply"
                    color="#FFF"
                    style={{ fontSize: 15, marginRight: 5 }}
                  />
                  Back To Home
                </button>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

//  export default Success;
const mapStateToProps = (state) => ({
  userDetail: state.SignInReducer.logindetails,
});

export default connect(mapStateToProps)(CategorySuccess);
